import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { RoleService } from "./role-service";
import { RoleEntity } from "./role-entity";
import { RoleController } from "./role-controller";

@Module({
  imports: [TypeOrmModule.forFeature([RoleEntity])],
  controllers: [RoleController],
  providers: [RoleService, ApplicationExceptionHandler],
})
export class RoleModule {}
